import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { siteUrl, locales } from '../data/metadata';


const BreadcrumbSchema = ({ pagePath }) => {
  if (!pagePath) return null;

  const segments = pagePath.split('/').filter(Boolean);
  if (segments.length < 1) return null;

  const items = segments.map((segment, index) => {
    const path = `/${segments.slice(0, index + 1).join('/')}/`;
    const isLocale = index === 0 && locales.includes(segment);
    const name = isLocale
      ? 'Home'
      : segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
    return {
      '@type': 'ListItem',
      position: index + 1,
      name,
      item: `${siteUrl}${path}`,
    };
  });

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

BreadcrumbSchema.propTypes = {
  pagePath: PropTypes.string,
};

export default BreadcrumbSchema;
